import { createContext, ReactNode } from 'react'

export const SvgIconSheetContext = createContext<string | null>(null)

export interface SvgIconSheetProviderProps {
  children: ReactNode
  svgIconSheetPath: string
}

export const SvgIconSheetProvider = ({
  children,
  svgIconSheetPath,
}: SvgIconSheetProviderProps) => (
  <SvgIconSheetContext.Provider value={svgIconSheetPath}>
    {children}
  </SvgIconSheetContext.Provider>
)
